import { Inbox } from "lucide-react";

const Empty = () => (
  <div className="text-center py-18 px-4 text-slate-400">
    <Inbox size={40} color="#cbd5e1" strokeWidth={1} className="mx-auto mb-3.5" />
    <p className="text-sm m-0">Aucune donnée disponible pour cette période.</p>
  </div>
);

export default Empty;